import { formatPriceCompact } from '@kijiji/money'
import { formatWholeNumber } from '@kijiji/number/formatWholeNumber'
import { type TFunction } from 'i18next'

import { getLocale, ROUTE_LOCALE } from '@/domain/locale'
import { type RangeFilterMinMax } from '@/types/search'

export type FormattedRange = { min: string | null; max: string | null }

export const RANGE_FILTER_LABEL_OVERRIDE = {
  FORMAT_NUMBER: ({ selectedRangeValues }: RangeFilterMinMax): FormattedRange => {
    const { routeLocale } = getLocale()
    const isEnglish = routeLocale === ROUTE_LOCALE.en

    return {
      min: selectedRangeValues?.min ? formatWholeNumber(selectedRangeValues.min, isEnglish) : null,
      max: selectedRangeValues?.max ? formatWholeNumber(selectedRangeValues.max, isEnglish) : null,
    }
  },
  FORMAT_PRICE_SHORTHAND: ({ selectedRangeValues }: RangeFilterMinMax): FormattedRange => {
    const { routeLocale } = getLocale()
    const isFrench = routeLocale === ROUTE_LOCALE.fr

    return {
      min: selectedRangeValues?.min
        ? formatPriceCompact(selectedRangeValues.min, { isFrench })
        : null,
      max: selectedRangeValues?.max
        ? formatPriceCompact(selectedRangeValues.max, { isFrench })
        : null,
    }
  },
  FORMAT_RANGE: (name: string, selectedRangeValues: FormattedRange, t: TFunction) => {
    const minValue = selectedRangeValues?.min
    const maxValue = selectedRangeValues?.max

    if (!maxValue) {
      return t(`srp:filters.description.${name}.from`, { minValue })
    }
    if (!minValue) {
      return t(`srp:filters.description.${name}.to`, { maxValue })
    }

    return `${minValue} - ${maxValue}`
  },
}
